module.exports = __webpack_public_path__ + "static/minh-screenshot-76c3076471a17c1f821befaa4b46d3ea.jpg";